module.exports = __webpack_public_path__ + "img/Colorz.3436a318.svg";